import * as React from 'react';
import { TechnologyName } from '~/common/enums/enums';
import { Image } from '~/components/common/common';
import { getValidClasses } from '~/helpers/helpers';
import { technologyNameToDetails } from '../maps';
import * as styles from './tech-list.module.scss';

type Props = {
  items: TechnologyName[];
  className?: string;
};

const TechList: React.FC<Props> = ({ items, className }) => {
  return (
    <ul className={getValidClasses(styles.list, className)}>
      {items.map((item) => (
        <li className={styles.item} key={item}>
          <div className={styles.iconWrapper}>
            <Image
              className={styles.icon}
              src={technologyNameToDetails[item].icon}
              alt={technologyNameToDetails[item].label}
            />
          </div>

          <span className={styles.label}>
            {technologyNameToDetails[item].label}
          </span>
        </li>
      ))}
    </ul>
  );
};

export { TechList };
